import { createContext } from 'react';
import type { z } from 'zod';

interface FormSchema {
  schema: z.ZodType;
}

export const FormSchemaContext = createContext<FormSchema | undefined>(
  undefined,
);

FormSchemaContext.displayName = 'FormSchemaContext';
